module.exports = __webpack_public_path__ + "img/Hino Finance.e4a64830.png";